import { render } from "./QuickMenu.vue?vue&type=template&id=536a943c"
import script from "./QuickMenu.vue?vue&type=script&lang=js"
export * from "./QuickMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__